<script lang="ts">
  import type { GetContractResult } from '../../../../repositories/contract';

  const SERVICE_CODE_CALCULATION = [
    'HIKARI_01_LINE_VDSL_1_DIVIDED',
    'HIKARI_01_LINE_VDSL_1_LUMPSUM',
    'HIKARI_01_LINE_LAN_1_DIVIDED',
    'HIKARI_01_LINE_LAN_1_LUMPSUM'
  ];

  const SERVICE_CODE_FIXED = [
    'HIKARI_01_LINE_VDSL_2_DIVIDED',
    'HIKARI_01_LINE_VDSL_2_LUMPSUM',
    'HIKARI_01_LINE_LAN_2_DIVIDED',
    'HIKARI_01_LINE_LAN_2_LUMPSUM'
  ];

  const CAMPAIGN_CODE_OTHER = ['LINE_SPAAQS_FOR_LAN_4', 'LINE_SPAAQS_FOR_MULTI_1', 'LINE_SPAAQS_FOR_MULTI_2'];

  export let contract!: GetContractResult;
  export let handleConfirmEvent!: any;

  const handleConfirm = (): void => {
    handleConfirmEvent();
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">違約金について</h1>
    </div>
  </div>
  {#if SERVICE_CODE_CALCULATION.includes(contract.serviceCode)}<!-- パターン1 違約金計算 -->
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex flex-col">
        <div class="flex-1 m-10">
          <div class="inline-flex justify-items-center items-center min-w-full">
            <div class="mb:font-sm w-full">
              <p>開通月の2年後の応当月より前に解約する場合、違約金が必要となります。</p>
              <p>※当該違約金は、残余期間に1,000円を乗じて算出します</p>
              <p>
                また、開通月の1年後の応当月より前に解約する場合は、上記に加え、早期契約解除金(9,500円)が必要となります
              </p>
            </div>
          </div>
          <div class="flex flex-col justify-items-center items-center mt-10">
            <div class="content-center">
              <img class="scale-100 object-fill w-full" src="/image/penalty_sample.png" alt="penalty-sample" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col justify-items-center items-center">
        <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
          <button class="button-primary md:ml-5 mb-5" on:click={handleConfirm}> 確認 </button>
        </div>
      </div>
    </div>
  {:else if SERVICE_CODE_FIXED.includes(contract.serviceCode)}<!-- パターン2 違約金固定 -->
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex-1 m-10">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <div class="mb:font-sm w-full">
            <p>開通月の2年後の応当月より前に解約する場合、違約金(2,980円)が必要となります。</p>
            <p class="mt-4">
              例) 2022年7月に開通した場合、2022年7月〜2024年6月に解約する場合、2,980円の解約金が必要となります
            </p>
          </div>
        </div>
      </div>
      <div class="flex flex-col justify-items-center items-center">
        <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
          <button class="button-primary md:ml-5 mb-5" on:click={handleConfirm}> 確認 </button>
        </div>
      </div>
    </div>
  {:else if CAMPAIGN_CODE_OTHER.includes(contract.campaignCode)}<!-- パターン3 違約金計算・固定以外 -->
    <div class="shadow rounded bg-white border-t-2 border-green-400">
      <div class="flex-1 m-10">
        <div class="inline-flex justify-items-center items-center min-w-full">
          <div class="mb:font-sm w-full">
            <p>開通月の前月を基準として、1年ごとの応当月以外に解約する場合、違約金が必要となります。</p>
            <p class="mt-4">
              例)2014年9月に開通した場合、2022年8月、2023年8月、、、に解約する場合は違約金は不要ですが8月以外に解約する場合、違約金が必要となります
            </p>
          </div>
        </div>
      </div>
      <div class="flex flex-col justify-items-center items-center">
        <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
          <button class="button-primary md:ml-5 mb-5" on:click={handleConfirm}> 確認 </button>
        </div>
      </div>
    </div>
  {:else}
    <!-- 上記以外は何も表示しない -->
  {/if}
</div>

<style lang="postcss">
  p {
    @apply tracking-normal mb-1;
  }
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
